var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  Loading...\n  "),_c('br'),_vm._v(" "),(_vm.wobble)?_c('div',[_c('amenity-manatee-wobble')],1):_c('div',[_c('amenity-manatee-crank')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }